import { ChangeDetectionStrategy, Component, EventEmitter, inject, input, InputSignal, Output } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { RestrictedDirective } from "@shared/directives/restricted/restricted.directive";
import { Permission } from '@shared/types/permission.types';
import { IconModule } from "@ogs-gmbh/ngx-m3-components";
import { provideTranslationScope, TranslationPipeModule } from '@ogs-gmbh/ngx-translate';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-overview-header-add',
  standalone: true,
  imports: [ RestrictedDirective, IconModule, TranslationPipeModule, MatButtonModule ],
  providers: [
    provideTranslationScope("shared/overview-header")
  ],
  templateUrl: './overview-header-add.component.html',
  styleUrl: './overview-header-add.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewHeaderAddComponent {
  private readonly _faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  public permissions: InputSignal<Permission[]> = input<Permission[]>([]);

  @Output() public readonly addClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();


  constructor () {
    this._faIconLibrary.addIcons(faPlus);
  }


  protected onAddClick (mouseEvent: MouseEvent): void {
    this.addClick.emit(mouseEvent);
  }
}
